import React from "react";
import { Box, TablePagination } from "@mui/material";

interface PickerPaginationProps {
  needsPagination: boolean;
  totalItems: number;
  rowsPerPage: number;
  page: number;
  onPageChange: (event: unknown, newPage: number) => void;
  onRowsPerPageChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  isMobile: boolean;
}

export const PickerPagination: React.FC<PickerPaginationProps> = ({
  needsPagination,
  totalItems,
  rowsPerPage,
  page,
  onPageChange,
  onRowsPerPageChange,
  isMobile,
}) => {
  if (!needsPagination) {
    return null;
  }

  return (
    <Box
      sx={{
        p: 2,
        borderTop: "1px solid #e0e0e0",
        mb: 4,
        overflow: "hidden",
        "& .MuiTablePagination-root": {
          overflow: "hidden",
        },
        "& .MuiTablePagination-toolbar": {
          flexWrap: "wrap",
          gap: 1,
          "& .MuiTablePagination-selectLabel, & .MuiTablePagination-displayedRows":
            {
              fontSize: isMobile ? "0.75rem" : "0.875rem",
            },
          "& .MuiTablePagination-select": {
            fontSize: isMobile ? "0.75rem" : "0.875rem",
          },
        },
        "& .MuiTablePagination-actions": {
          flexShrink: 0,
        },
      }}
    >
      <TablePagination
        rowsPerPageOptions={isMobile ? [12, 24] : [24, 48, 96]}
        component="div"
        count={totalItems}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={onPageChange}
        onRowsPerPageChange={onRowsPerPageChange}
        labelRowsPerPage={isMobile ? "Rows:" : "Rows per page:"}
        labelDisplayedRows={({ from, to, count }) =>
          isMobile
            ? `${from}-${to} of ${count}`
            : `${from}-${to} of ${count !== -1 ? count : `more than ${to}`}`
        }
      />
    </Box>
  );
};
